import state from '../../state'

/**
 * Calls the sdk manager method having the given name with the given payload.
 *
 * @param {Object} param
 * @param {String} param.method - sdk manager method name
 * @param {Object} param.payload - payload to invoke method with
 * @returns {*}
 */
export default function handleSrciRequest ({ data }) {
  return state.aggregator.src[data.method](...data.payload)
}
